import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';

@Injectable({
  providedIn: 'root'
})

export class ODSService {
  private apiUrl = 'http://35.232.140.117:3800/api_empresa/Institutos';
  // private ip = 'http://35.232.140.117:3800';

  constructor(private httpClient: HttpClient,
  private authService:AuthService) {

  }

  public getInstituteArray() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArray);
    // return this.httpClient.get(this.ip+'/api_empresa/Institutos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public updateElement(id,data) {

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.updateODS+id,data);
    // return this.httpClient.get(this.ip+'/api_empresa/Institutos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public sendEmails(id) {
    let data = {};
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.enviaEmail+id,data);
    // return this.httpClient.get(this.ip+'/api_empresa/Institutos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getUserinfo(id) {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.user+id);
    // return this.httpClient.get(this.ip+'/api_empresa/Institutos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getPlantillas(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.getPlantillas, data);
    // return this.httpClient.post(this.ip+'/api_empresa/CatalogoPlantillas', data, { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getEmail_Plantillas(data) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.getEmail_Plantillas, data);
    // return this.httpClient.post(this.ip+'/api_empresa/templatesComunicacion', data, { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public getSectorarray() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.ods.getSectorarray);
    // return this.httpClient.get(this.ip+'/api_empresa/Sectores', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public getRankingrray() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.ods.getRankingrray);
    // return this.httpClient.get(this.ip+'/api_empresa/Ranking', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getRegiones(data?:any) {
    console.log(data);

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.getRegiones,data);
    // return this.httpClient.get(this.ip+'/api_empresa/Ranking', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getProductsArray() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.productos);
    // return this.httpClient.get(this.ip+'/api_empresa/Productos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getYearsArray() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.ods.getYearsArray);
    // return this.httpClient.get(this.ip+'/api_empresa/Anios', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getestilos() {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.getestilo,null);
    // return this.httpClient.post(this.ip+'/api_empresa/estilos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public registerODS(data){


    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.empresas, data);
    // return this.httpClient.post(this.ip+'/api_empresa/Empresas', data,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public editODS(data){


    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.empresasEdit, data);//"http://app06.culturalgo.com:3800/api_empresa/Empresas/edit/",data);//DATOS_API.url + DATOS_API.endpoints.empresasEdit, data);
    // return this.httpClient.post(this.ip+'/api_empresa/Empresas', data,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public getCompanies(datos:any) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.empresasGET,datos);
    // return this.httpClient.get(this.ip+'/api_empresa/Empresas', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

///api_empresa/Productos/Actuales/aqui va el ID de empresa
  public getProductsByCompany(idCompany) {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.ods.getProductsByCompany+idCompany);
    // return this.httpClient.get(this.ip+'/api_empresa/Productos/Actuales/'+idCompany,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
  public deleteProductCompany(idCompany,idProduct) {
  return this.httpClient.delete(DATOS_API.url + DATOS_API.endpoints.certificar3.focusV3.deleteEncuestaFocus+idCompany+'/'+idProduct);
  }

  public matchCompanyProduct(idCompany,data){


    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.productos+idCompany, data);
    // return this.httpClient.post(this.ip+'/api_empresa/Productos/'+idCompany, data,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public updateStatus(idCompany,data){


    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.updateStatus+idCompany, data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/update/'+idCompany, data,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }

  public getEnterpriseDetail(idEnterprise : string) {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.empresas+idEnterprise);
    // return this.httpClient.get(this.ip+'/api_empresa/Empresas/'+idEnterprise,
    //                             { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getProductosEmpresa(idEmpresa){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.productos + idEmpresa);
  }

  public getdatosencuesta(datos){
    console.log(datos);

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.consultarencuesta, datos);
  }

  public getListaEmpresas(datos:any, pagina:number){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.getListaEmpresas + pagina, datos);
  }

    getEncuestasActivas(datos){
    console.log(datos);

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getEncuestasAct,datos);
    }

    public getEncuesta(idEmpresa,idProducto){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getEncuesta + idEmpresa+'/'+idProducto);
    }

    public getEncuestaNorma(idEmpresa,idProducto){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getEncuestaNorma + idEmpresa+'/'+idProducto);
    }

    getAuditoriaMenor10Min(idConfiguration){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.aditoriaAtoumatizada.getMenos10Min + idConfiguration);
    }

    crearMuestraMenor10Min(idConfiguration,productoId,data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.aditoriaAtoumatizada.crearMuestrasMenos10Min + idConfiguration+'/'+productoId,data);
    }

    getMuestraMenor10Min(productoID){
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.aditoriaAtoumatizada.getMuestrasMenos10Min + productoID);
    }


    actualizarCA(idCompany, datos){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.ods.actualizarCA + idCompany, datos);
    }

    editarComentarioAuditoria(idColaborador, datos){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.aditoriaAtoumatizada.editarComentario + idColaborador, datos);
    }

    getEncuestaBylang(idEmpresa,idProducto,idIdioma){
      let datos: any = {idiomaId: idIdioma};
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getEncuesta + idEmpresa+'/'+idProducto,datos);
    }

    getEncuestaProductosv3a(idProducto,idIdioma,instituto){
      let datos: any = {claveIdioma: idIdioma,institutoId:instituto,extra:"otro"};
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.descargaEncuestaV3 +idProducto,datos);
    }

    public getEncuestaNorma35(idEmpresa,idProducto,bandera){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getEncuestaNorma + idEmpresa+'/'+idProducto+'/'+bandera);
    }

    borrarEmpresa(idEmpresa){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.deleteCompany + idEmpresa,null);
    }

    //SERVICIOS CERTIFICAR 3/MASTER CATALOG
    getTemplatesCertV3(instituto:any, idEmpresa:string){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getTemplatesCertV3 + instituto + "/" + idEmpresa);
    }
    sendEmailReqTecnicos(idEmpresa,productoID,datos){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.sendEmailRequerimientosTecnicos + idEmpresa+'/'+productoID,datos);
    }

    getCatalogos(numInstituto:any, idioma:string){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.getCatalogos + numInstituto + "/" + idioma);
    }
    getCatPaises(numInstituto:any, idioma:string){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.catPaises + numInstituto + "/" + idioma);
    }

    getDatosEmpresaAuditoria(token:any){
      let datos={surveyToken:token};
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getDatosEmpresaAuditoriaA,datos);
    }

    cambiarNombreEncuestaFocus(productoId,nameSurvey){
      let datos={productoId:productoId,nameSurvey:nameSurvey};
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.actualizaNombreEncuesta+localStorage.getItem('empresaID'),datos);
    }

    getBanderasReq(numInstituto:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.consultarRequerimientos + numInstituto);
    }

    getDemografResult(broker:any,productoId:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getResultadosDemograficos + broker+'/'+productoId);
    }
    saveDemografResult(infoFinal){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.saveResultadosDemograficos,infoFinal);
    }
    getsaveDemografResult(empresaId,token){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getResultadosDemograficosGuardados+ empresaId+'/'+token);
    }

    updateFlagCambios(empresaId,productoId,datos){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.updateFlagCambios+ empresaId+'/'+productoId,datos);
    }

    getHerachicalPa(surveryToken){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getHerachical+surveryToken);
    }
    savetHerachicalPa(surveryToken,datos){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.saveHerachical+surveryToken,datos);
    }
    getHerachicalPaGuardados(surveryToken){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getHerachicalGuardados+surveryToken);
    }
    getCultureAuditCGOX(empresaId:string, datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getCultureAuditCGOX + empresaId, datos);
    }

    createUsersActionGo(companyId,asociadoId,datos){

      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.actionGo.createUserActionGo+ companyId+'/'+asociadoId,datos);
    }

    getProjectManagerProduct(instituto){

      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getProjectManagerProduct+ instituto);
    }

    getPaisesBroker(broker:string){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getPaisesBroker + broker);
    }

    uploadRawDataFile(empresaId:any, datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.uploadRawDataFile + empresaId,datos);
    }
    getMasterFileService(ano){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getMasterFileService+ano);
    }

    getRankigRangeColab(instituto:any,lang:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getRankigRangeColab+instituto+'/'+lang);
    }

    deleteProduct(idEmpresa:any,datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.deleteProductEmpresa+idEmpresa,datos);
    }

    getCatalogoRangoColaboradores(broker:any,lang:any,country:any){
        return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getCatalogoRangoColaboradores + broker+'/'+lang+'/'+country);
    }

    getCat_typeOfResults(broker:any){
        return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getCat_typeOfResults + broker);
    }

    updateMasterTable(datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.updateMasterTable, datos);
    }

    updateBenchMark(empresaId:any,datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.updateBenchMark+empresaId, datos);
    }

    saveDataResultsGoFlow(empresaId:any, datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.saveDataResultsGoFlow+empresaId,datos);
    }
    saveDataResultsGoFlowSQL(empresaId:any, datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.saveDataResultsGoFlowSQL+empresaId,datos);
    }

    getDataResultsGoFlow(empresaId:any, productoId:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getDataResultsGoFlow+empresaId+"/"+productoId);
    }

    signUpUserSwift(datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.swift.signUpUser,datos);
    }

    saveProductSwift(empresaId:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.swift.saveProductSwift+empresaId,{});
    }

    getCatBenchMark(broker:any,token:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getCatBenchMark+broker+"/"+token);
    }

    SaveBenchMark(surveyToken:any, datos:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.SaveBenchMark+surveyToken,datos);
    }

    getMyBenchMarks(surveyToken:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getMyBenchMarks+surveyToken);
    }

    getReportSurveyGeneric(surveyToken:any){
      return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getReportSurveyGeneric+surveyToken);
    }

    deleteBenchMarkNoAplic(surveyToken:any){
      return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.deleteBenchMarkNoAplic+surveyToken,{});
    }

    update_typeOfResults(empresaId:any, productoId:any,datos:any){
        return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.updateProductResultsType + empresaId+'/'+ productoId,datos);
    }

    public addProductv2(idCompany,data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.addProductv2+idCompany, data);
    }

     create_Infrastructure(idCompany,data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.create_Infrastructure+idCompany, data);
    }

    saveJsonProductVirtualSMS(idCompany,data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.saveJsonProductVirtualSMS+idCompany, data);
    }


}
